import { useApolloClient } from '@apollo/client';
import {
  ListConversationsDocument,
  ListConversationsQuery,
  useOnConversationUpdateSubscription,
} from '@graphql';
import { useSession, useToastError } from '@hooks';

export function useConversationSubscription() {
  const { account } = useSession();
  const toastError = useToastError();
  const client = useApolloClient();

  useOnConversationUpdateSubscription({
    skip: !account,
    onError: toastError,
    onData: ({ data }) => {
      const update = data.data?.conversationUpdate;
      if (!update) return;

      client.cache.updateQuery<ListConversationsQuery>({ query: ListConversationsDocument }, (prev) => {
        const prevList = prev?.conversations ?? [];
        const idx = prevList.findIndex((c) => c.id === update.id);

        if (idx === -1) {
          return { conversations: [update, ...prevList] };
        }

        const next = prevList.slice();
        next[idx] = update;
        return { conversations: next };
      });
    },
  });

  return null;
}
